import { useMemo } from 'react'

import { Filter, X } from 'lucide-react'
import type { FC } from 'react'

import type { CustomFilterShape } from './useFilters'

interface OpenDialogButtonProps {
	filters: CustomFilterShape
	columns: Record<string, string>
}

export const OpenDialogButton: FC<OpenDialogButtonProps> = ({
	filters,
	columns,
}) => {
	const hasFilters = useMemo(() => Object.keys(filters).length > 0, [filters])
	const filteredBy = useMemo(
		() =>
			Object.keys(filters)
				.map(filter => columns[filter] ?? filter)
				.join(', '),
		[filters, columns]
	)

	return (
		<div className="flex items-center gap-2">
			<Filter aria-hidden="true" />
			<span>{hasFilters ? `Filtered by ${filteredBy}` : 'Filter'}</span>
		</div>
	)
}
